import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { encryptText } from "../helper/encryptHelper";
import io from "socket.io-client";

export const lotteryReducer = createSlice({
  name: "lottery",
  initialState: {
    allLottery: null,
    lotteryRound: null,
    loading: true
  },
  reducers: {
    setAllLottery: (state, { payload }) => {
      state.allLottery = payload;
    },
    setRoundLottery: (state, { payload }) => {
      state.lotteryRound = payload;
    },
    setUpdateRoundLottery: (state, { payload }) => {
      // console.log(state.lotteryRound)
      // console.log(state)
      const arr = JSON.parse(JSON.stringify(state.lotteryRound));
      // console.log(arr)
      // arr[arr.length - 1] = payload;
      arr.data[arr.data.length - 1] = payload
      state.lotteryRound = arr
    },
    setLotteryFromSearch: (state, { payload }) => {
      state.lotteryFromSearch = payload
      state.loading = false
    },
    setLotteryNextFromSearch: (state, { payload }) => {
      console.log(payload)
      state.lotteryFromSearch = [...state.lotteryFromSearch, ...payload];
      state.loading = false
    }
  },
});

export const { setAllLottery, setRoundLottery, setUpdateRoundLottery, setLotteryFromSearch, setLotteryNextFromSearch } = lotteryReducer.actions;
export default lotteryReducer.reducer;

let socketHuay;

const header2 = {
  headers: {
    "Content-Type": "application/text/plain",
    Authorization: `Bearer ${localStorage.getItem("Token")}`,
  },
};

const getAllLottery = (data) => async (dispatch) => {
  const body = { webGroup: process.env.REACT_APP_AGENT };
  const cryptoData = encryptText(
    JSON.stringify(body),
    data?.key || localStorage.getItem("Key")
  );

  const header = {
    headers: {
      "Content-Type": "application/text/plain",
      Authorization: `Bearer ${data?.token || localStorage.getItem("Token")}`,
    },
  };

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_PROVIDER}/api/lotteryRound/cusSite/getLatestLotteryRoundsFromOuterLotteries_v4`,
      cryptoData,
      header

    );
    if (res.data.code === "999999") {
      dispatch(setAllLottery(res.data.data.result));
    }
  } catch (err) {
    console.error(err);
  }
};
const getAllLotteries = () => async (dispatch) => {

  try {
    let header = {
      headers: {
        'accept': 'application/json; charset=UTF-8',
        'content-type': 'text/plain',
        'authorization': `Bearer ${localStorage.getItem("Token")}`,
      }
    }
    const res = await axios.get(
      `${process.env.REACT_APP_API_LOTTERY}/api/lottery/boSite/getAllLotteries`,
      header

    );
    if (res.data.code === "999999") {
      dispatch(setAllLottery(res.data.data));
      return res.data.data
    }
  } catch (err) {
    console.error(err);
  }
};


const getLotteryRound = (data) => async (dispatch) => {
  const date = new Date().setHours(0, 0, 0, 0);
  const body = {
    lottery: localStorage.getItem("lotteryId"),
    member: "625fae71714af20bc491c73f",
    roundDate: new Date(date),
  };
  const cryptoData = encryptText(
    JSON.stringify(body),
    localStorage.getItem("Key")
  );
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_PROVIDER}/api/lotteryRound/cusSite/getLotteryRoundsSort`,
      cryptoData,
      header2
    );
    if (res.data.code == "999999") {
      dispatch(setRoundLottery(res.data));
    }
  } catch (err) {
    console.error(err);
  }
};

const SocketResultHuay = () => {
  socketHuay = io(process.env.REACT_APP_API_SOCKET_LOTTERY, {
    auth: {
      token: `Bearer ${localStorage.getItem("Token")}`,
    },
  });
  if (socketHuay) {
    // console.log("come to huayyak", socketHuay);
    socketHuay.on("connect_error", (err) => {
      console.log(`connect_error due to ${err.message}`);
    });
  }
};

const getSocketYeekeeResult = () => async (dispatch) => {
  socketHuay?.on("lotteryRound_results_updated", (msg) => {
    // console.log("socket detected!!!");
    // console.log(msg);
    if (localStorage.getItem("lotteryId") === msg.lottery._id) {
      dispatch(setUpdateRoundLottery(msg));
    }
  });
};

const disconnectHuayYak = () => {
  if (socketHuay) {
    socketHuay.disconnect()
    // console.log("Disconnecting socketHuay....", socketHuay);
  }
};

export {
  getAllLottery,
  getLotteryRound,
  SocketResultHuay,
  getSocketYeekeeResult,
  disconnectHuayYak,
  getAllLotteries,
  getLotteryFromSearch,
  pushLotteryFromSearch
};
const getLotteryFromSearch = (Number) => async (dispatch) => {
  try {
    var typeApi = ""
    dispatch(setLotteryFromSearch(null))
    // console.log("lotteryName :", localStorage.getItem("lotteryName"))
    const strOfNumberPattern = Number?.map(data => {
      if (data.toString() == "") {
        data = "_"
        return data
      }
      return data
    }).join("")
    if (!strOfNumberPattern || strOfNumberPattern == "______") {
      console.log("randomJackpotLottoTickets :", strOfNumberPattern)
      typeApi = "/api/lotteryTicket/cusSite/randomJackpotLottoTickets"
    } else {
      console.log("searchJackpotLottoTickets :", strOfNumberPattern)
      typeApi = "/api/lotteryTicket/cusSite/searchJackpotLottoTickets"
    }
    const body = {
      lotteryRound: localStorage.getItem("roundId"),
      betNumber: strOfNumberPattern ? strOfNumberPattern : "______",
      pageSize: 16
    }
    const cryptoData = encryptText(
      JSON.stringify(body),
      localStorage.getItem("Key")
    );
    const res = await axios.post(
      `${process.env.REACT_APP_API_LOTTERYINVOICE}${typeApi}`,
      cryptoData,
      header2
    )
    // console.log("asdasd", res.data)
    if (res.data.code === "999999") {
      dispatch(setLotteryFromSearch(res.data.data))
    }

  } catch (error) {
    console.error(error)
  }
}

const pushLotteryFromSearch = (Number, lotteryFromSearch) => async (dispatch) => {
  try {
    var typeApi = ""
    const strOfNumberPattern = Number?.map(data => {
      if (data.toString() == "") {
        data = "_"
        return data
      }
      return data
    }).join("")
    if (!strOfNumberPattern || strOfNumberPattern == "______") {
      console.log("randomJackpotLottoTickets :", strOfNumberPattern)
      typeApi = "/api/lotteryTicket/cusSite/randomJackpotLottoTickets"
    } else {
      console.log("searchJackpotLottoTickets :", strOfNumberPattern)
      typeApi = "/api/lotteryTicket/cusSite/searchJackpotLottoTickets"
    }
    console.log("otteryFromSearch[lotteryFromSearch.length]._id :", lotteryFromSearch[lotteryFromSearch.length - 1]._id)
    const body = {
      lotteryRound: localStorage.getItem("roundId"),
      betNumber: strOfNumberPattern ? strOfNumberPattern : "______",
      pageSize: 16,
      last_id: lotteryFromSearch[lotteryFromSearch.length - 1]._id
    }
    const cryptoData = encryptText(
      JSON.stringify(body),
      localStorage.getItem("Key")
    );
    const res = await axios.post(
      `${process.env.REACT_APP_API_LOTTERYINVOICE}${typeApi}`,
      cryptoData,
      header2
    )
    console.log("asdasdasd :", res.data.data)
    if (res.data.code === "999999") {
      dispatch(setLotteryNextFromSearch(res.data.data))
    }
  } catch (error) {
    console.error(error)
  }
}

